import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import UserNote from "@/components/UserNote.vue";
import { userNotesService } from "@/services/userNotesService";
import { orderInfoService } from "@/services/orderInfoService";
import { useIntakeActions } from "@/composables/useIntakeActions";
import { ref } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ArchiveNote',
    props: {
        orderInfo: {
            type: Object,
            required: false,
            default: null,
        },
        intakeOrder: {
            type: Object,
            required: false,
            default: null,
        },
        intakeDocument: {
            type: Object,
            required: false,
            default: null,
        },
    },
    emits: ["on-archived"],
    setup(__props, { emit: __emit }) {
        const intakeActions = useIntakeActions();
        const props = __props;
        const emit = __emit;
        const errorMsg = ref(null);
        const showLoader = ref(false);
        const addArchiveNote = async (note) => {
            try {
                showLoader.value = true;
                errorMsg.value = null;
                let didArchive = false;
                if (props.orderInfo) {
                    await orderInfoService.archiveOrder(props.orderInfo.orderKey);
                    didArchive = true;
                }
                else if (props.intakeOrder) {
                    await intakeActions.onArchive({ orderId: props.intakeOrder.id, reRouteOnSuccess: false });
                    didArchive = true;
                }
                else if (props.intakeDocument) {
                    await intakeActions.onArchive({
                        documentKey: props.intakeDocument.documentKey,
                        reRouteOnSuccess: false,
                    });
                    didArchive = true;
                }
                if (didArchive) {
                    await userNotesService.createNote({
                        orderInfo: props.orderInfo?.orderKey,
                        intakeOrder: props.intakeOrder?.id,
                        intakeDocument: props.intakeDocument?.documentKey,
                        note: note,
                        level: "archive_reason",
                    });
                    emit("on-archived");
                }
                return didArchive;
            }
            catch (error) {
                errorMsg.value = `Failed to add archive note: ${error.message?.toString() ?? error}`;
                return false;
            }
            finally {
                showLoader.value = false;
            }
        };
        return (_ctx, _cache) => {
            const _component_v_alert = _resolveComponent("v-alert");
            const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (errorMsg.value)
                    ? (_openBlock(), _createBlock(_component_v_alert, {
                        key: 0,
                        type: "error"
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(errorMsg.value), 1)
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                _createVNode(_component_v_skeleton_loader, {
                    loading: showLoader.value,
                    type: "article, article",
                    style: _normalizeStyle({ display: 'block', backgroundColor: showLoader.value ? undefined : 'transparent' })
                }, {
                    default: _withCtx(() => [
                        _createVNode(UserNote, {
                            title: "Archive Reason",
                            "add-note-button-label": "Add Note & Archive",
                            "order-info-id": __props.orderInfo?.orderKey,
                            "intake-order-id": __props.intakeOrder?.id,
                            "intake-document-id": __props.intakeDocument?.documentKey,
                            "override-add-note": addArchiveNote
                        }, null, 8, ["order-info-id", "intake-order-id", "intake-document-id"])
                    ]),
                    _: 1
                }, 8, ["loading", "style"])
            ], 64));
        };
    }
});
